import { render, staticRenderFns } from "./manage-match-list.vue?vue&type=template&id=5aed0b89&scoped=true&"
import script from "./manage-match-list.vue?vue&type=script&lang=js&"
export * from "./manage-match-list.vue?vue&type=script&lang=js&"
import style0 from "./manage-match-list.vue?vue&type=style&index=0&id=5aed0b89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aed0b89",
  null
  
)

export default component.exports